// @ts-nocheck
import { QuantitySelectorUpdateEvent } from './events.js';
import { isNumeric } from './helper-functions.js';
import { fetchCartItems } from './add-to-cart-functions.js';

const css = /* css */`
:host {
  position: relative;
  display: inline-block;
  width: fit-content;
}

.quantity-selector__button {
  width: 72px;
  border: 1px solid #fff;
  padding: 8px;
  border-radius: 999px;
  color: #fff;
  cursor: pointer;
  background-color: transparent;
  transition: background-color var(--animation-speed), color var(--animation-speed);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-selector__button:hover {
  background-color: #fff;
  color: #131313;
}

.quantity-selector__button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 4px;
}

.quantity-selector__button .quantity-selector__chevron {
  width: 16px;
  height: 16px;
  transform: rotate(90deg);
  transition: transform var(--animation-speed) var(--animation-easing);
  flex-shrink: 0;
  margin-left: auto;
  top: auto;
}

.quantity-selector__button .quantity-selector__chevron.active {
  transform: rotate(-90deg);
}

.quantity-selector__selected-value {
  white-space: nowrap;
  text-align: center;
  min-width: 10px;
}

.quantity-selector__options-container {
  display: none;
  flex-direction: column;
  position: absolute;
  top: 105%;
  left: 0;
  z-index: 100;
  width: max-content;
  background-color: white;
  box-shadow: 0 9px 60px rgba(0,0,0,.04),0 3.75998px 25.0666px rgba(0,0,0,.029),0 2.01027px 13.4018px rgba(0,0,0,.024),0 1.12694px 7.51293px rgba(0,0,0,.02),0 .598509px 3.99006px rgba(0,0,0,.016),0 .249053px 1.66035px rgba(0,0,0,.011);
  border-radius: var(--style-border-radius-xs);
  height: 220px;
  overflow: auto;
  list-style: none;
  margin: 0;
  padding: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity var(--animation-speed) var(--animation-easing), top var(--animation-speed) var(--animation-easing);
}

.quantity-selector__options-container.active {
  display: flex;
  opacity: 1;
  top: 115%;
  pointer-events: auto;
}

.quantity-selector__option {
  display: flex;
  align-items: center;
  gap: var(--gap-xs);
  padding: var(--input-padding);
  cursor: pointer;
  user-select: none;
  color: #131313;
}

.quantity-selector__option:hover {
  background-color: var(--color-input-hover-background);
}

.quantity-selector__option:not(:last-child) {
  border-bottom: 1px solid rgba(230, 230, 230, 1.0);
}

.quantity-selector__option .quantity-selector__radio-outer-circle {
  background-color: #fff;
  width: 22px;
  height: 22px;
  min-width: 22px;
  min-height: 22px;
  border-radius: 50%;
  border: 1px solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.quantity-selector__option .quantity-selector__radio-inner-circle {
  background-color: transparent;
  width: 13px;
  height: 13px;
  min-width: 13px;
  min-height: 13px;
  border-radius: 50%;
  transition: background-color var(--animation-speed) ease;
}

.quantity-selector__option .quantity-selector__radio-inner-circle.active {
  background-color: #00f;
}

.quantity-selector__option:hover .quantity-selector__radio-inner-circle:not(.active) {
  background-color: #000;
}
`;


class CartItemQuantityDropdown extends HTMLElement {
  static observedAttributes = [
    'data-item-key',
    'data-quantity',
    'data-line-index',
    'data-product-handle',
    'data-variant-id',
  ];

  itemKey = 'undefined';
  selectedQuantity = 1;
  productHandle = 'undefined';
  variantId = NaN;
  quantityMin = 1;
  quantityMax = 10;
  lineIndex = -1;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
    this.isOpen = false;
    this.shadow.addEventListener('click', this.handleShadowClick.bind(this));
  }


  async connectedCallback() {
    this.itemKey = Number(this.getAttribute('data-item-key')) ?? 'undefined';
    this.productHandle = Number(this.getAttribute('data-product-handle')) ?? 'undefined';
    this.variantId = Number(this.getAttribute('data-variant-id')) ?? NaN;
    this.lineIndex = Number(this.getAttribute('data-line-index')) ?? 1;
    this.selectedQuantity = Number(this.getAttribute('data-quantity')) ?? 1;
    await this.render();
  }


  async attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-item-key') this.itemKey = newValue;
    if (name === 'data-line-index') this.lineIndex = newValue;
    if (name === 'data-quantity') this.selectedQuantity = Number(newValue);
    if (name === 'data-product-handle') this.productHandle = newValue;
    if (name === 'data-variant-id') this.variantId = newValue;
    await this.render();
  }


  handleShadowClick(e) {
    const button = e.target.closest('.quantity-selector__button');
    if (button) {
      this.toggleDropdownOptions(e);
      return;
    }

    const option = e.target.closest('.quantity-selector__option');
    if (option) {
      this.handleOptionClick(e);
      return;
    }
  }


  async handleOptionClick(e) {
    e.stopPropagation();

    const optionEl = e.target.closest('.quantity-selector__option');
    const newQuantity = Number(optionEl.dataset.quantity);
    this.closeDropdown();

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = [...cartItemsComponents]
      .filter(item => item instanceof HTMLElement && item.dataset.sectionId)
      .map(item => item.dataset.sectionId);

    const cartItemsComponent = document.querySelector('cart-items-component');
    cartItemsComponent.updateQuantity({
      line: this.lineIndex,
      quantity: newQuantity,
      action: 'change',
    });
  }


  toggleDropdownOptions(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }


  openDropdown() {
    const quantityDropdowns = document.querySelectorAll('cart-item-quantity-dropdown');
    document.querySelectorAll('cart-item-quantity-dropdown').forEach((dropdown) => {
      if (dropdown !== this) dropdown.closeDropdown();
    });

    const optionsList = this.shadow.querySelector('.quantity-selector__options-container');
    const chevron = this.shadow.querySelector('.quantity-selector__chevron');

    optionsList?.classList.add('active');
    chevron?.classList.add('active');
    this.isOpen = true;

    optionsList?.addEventListener('wheel', (e) => {
      e.stopPropagation();
    }, { passive: true });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.closeDropdown();
    }, { once: true });
  }


  closeDropdown() {
    const optionsList = this.shadow.querySelector('.quantity-selector__options-container');
    const chevron = this.shadow.querySelector('.quantity-selector__chevron');

    optionsList?.classList.remove('active');
    chevron?.classList.remove('active');
    this.isOpen = false;
  }


  generateOptions(min, max, selectedQuantity) {
    let options = '';
    for (let i = min; i <= max; i++) {
      const isSelected = i === selectedQuantity;
      options += /* html */`
        <li
          class="quantity-selector__option"
          data-quantity="${i}"
          ${isSelected ? 'data-selected="true"' : ''}
        >
          <div class="quantity-selector__radio-outer-circle">
            <div class="quantity-selector__radio-inner-circle ${isSelected ? 'active' : ''}"></div>
          </div>
          <span>${i}</span>
        </li>
      `;
    }
    return options;
  }


  async render() {
    this.shadow.innerHTML = /* html */`
      <style>${css}</style>
      <button type="button" class="quantity-selector__button">
        <span class="quantity-selector__selected-value">${this.selectedQuantity}</span>
        <svg class="quantity-selector__chevron" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd" d="M8.591 6.487a.555.555 0 00-.766 0 .512.512 0 000 .74L10.692 10l-2.867 2.773a.512.512 0 000 .74.555.555 0 00.766 0l3.25-3.143a.512.512 0 000-.74l-3.25-3.143z" fill="currentColor" fill-rule="evenodd"/>
        </svg>
      </button>
      <ul class="quantity-selector__options-container">
        ${this.generateOptions(this.quantityMin, this.quantityMax, this.selectedQuantity)}
      </ul>
      <input
        type="hidden"
        name="${this.lineIndex ? 'updates[]' : 'quantity'}"
        value="${this.selectedQuantity}"
        class="quantity-input"
        ${this.lineIndex ? `data-cart-line="${this.lineIndex}"` : ''}
      />
    `;
  }
}

if (!customElements.get('cart-item-quantity-dropdown')) {
  customElements.define('cart-item-quantity-dropdown', CartItemQuantityDropdown);
}
